import React from 'react'
import { Tabs, Tab, Box, createTheme, Switch, IconButton, Divider } from '@mui/material';
import { useState } from 'react';
import { Button, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import applicant from '../../images/profilePhoto.png';
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import Edit from '../../images/Edit.svg'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { styled } from '@mui/system';
import Upload from '../../images/portfolio.svg'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import Deactvation from './SignUp Dialog/Deactivation';
import Feedback from './SignUp Dialog/Feedback';

function EmployerProfile() {
    const [openDialog, setOpenDialog] = useState(false);
    const [switchValue, setSwitchValue] = useState(false);

    const handleSwitchChange = (event) => {
        setSwitchValue(event.target.checked);
        setOpenDialog(event.target.checked);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    }
    const hoverStyles = {
        borderRadius: '25px',
        backgroundColor: '#2544EE',
        color: '#fff',
    };

    const Input = styled('input')({
        display: 'none',
    });

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        // Perform upload logic here
        console.log('Uploaded file:', file);
    };



    return (
        <Layout>
            <UserLayout userRole={"employer"} >
                <Paper sx={{ height: '100%', background: '#F8FAFF', border: '1px solid #005CF64D', mt: 8, px: 2, py: 2, boxShadow: '0px 26.398801803588867px 52.797603607177734px -9.89954948425293px #3665D014', }}>
                    <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center' }}>
                        <Typography className='text1Bold' >
                            Are You Sure to Deactivate the Account?
                        </Typography>
                        <Switch sx={{ color: '#2544EE' }} checked={switchValue} onChange={handleSwitchChange} />
                        <Deactvation openDialog={openDialog} setOpenDialog={setOpenDialog}/>
                    </Box>

                    <Paper sx={{ background: '#F8FAFF', border: '1px solid #005CF64D', boxShadow: '0px 26.398801803588867px 52.797603607177734px -9.89954948425293px #3665D014', }}>
                        <Box position="relative" style={{ marginBottom: '20px' }}>
                            <img src={applicant} alt="cover photo" width="100%" height="150px" style={{ borderRadius: '20px' }} />
                            <IconButton
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '50%',
                                    padding: '5px',
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                }}
                            >
                                <img src={Edit} alt="cover photo" width="20px" height="20px" />
                            </IconButton>
                            <Box style={{
                                position: 'absolute',
                                bottom: '-75px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}>

                                <img
                                    src={applicant}
                                    alt="cover photo"
                                    width="150px"
                                    height="150px"

                                />
                                <Typography className='text1Bold' >
                                    Ackrolix Innovation
                                </Typography>
                                <Typography className='text2Mid' >
                                    IT Services |Private Sector
                                </Typography>
                            </Box>
                        </Box>

                        <Box className='mHide' sx={{ display: 'flex', flexDirection: 'column', float: 'right', mx: 1 }}>
                            <Button className='borderButton' sx={{ mt: 2 }}>
                                Share Profile
                            </Button>

                            <Button className='filledButton' sx={{ mt: 2 }}>
                                Edit Profile
                            </Button>
                        </Box>

                        <Grid container className='dHide' sx={{ mt: 12, px: 10 }}>
                            <Grid item xs={12}>
                                <Button className='borderButton'  >
                                    Share Profile
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Button className='filledButton' sx={{ mt: 2 }}>
                                    Edit Profile
                                </Button>
                            </Grid>


                        </Grid>

                        <Box sx={{ display: { xs: 'block', lg: 'flex' }, mt: { xs: 4, lg: 10 }, width: '100%' }}>
                            <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center' }}>
                                <EmailOutlinedIcon sx={{ color: '#2544EE', mx: 1 }} />
                                {/* <img src={Edit} alt="cover photo" width="20px" height="20px" /> */}
                                <Typography className='text2Mid'> AckrolixInnovaction@gmail.com</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center' }}>
                                <LanguageOutlinedIcon sx={{ color: '#2544EE', mx: 1 }} />
                                <Typography className='text2Mid'> www.Ackrolixinnovaction.com</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center' }}>
                                <BusinessOutlinedIcon sx={{ color: '#2544EE', mx: 1 }} />
                                <Typography className='text2Mid'> 2010</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center' }}>
                                <PeopleAltOutlinedIcon sx={{ color: '#2544EE', mx: 1 }} />
                                <Typography className='text2Mid'> 40-50</Typography>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', my: 2 }}>
                            <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center' }}>
                                <PhoneOutlinedIcon sx={{ color: '#2544EE', mx: 1 }} />
                                <Typography className='text2Mid'> 9876543421</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center' }}>
                                <LocationOnOutlinedIcon sx={{ color: '#2544EE', mx: 1 }} />
                                <Typography className='text2Mid'>136, Sector 44, Gurugram</Typography>
                            </Box>
                        </Box>


                    </Paper>

                    <Paper sx={{ background: '#F8FAFF', border: '1px solid #005CF64D', boxShadow: '0px 26.398801803588867px 52.797603607177734px -9.89954948425293px #3665D014', my: 4, px: 2, py: 2 }}>
                        <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography className='text1Bold' >
                                About
                            </Typography>
                            <IconButton
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '50%',
                                    padding: '5px',
                                }}
                            >
                                <img src={Edit} alt="cover photo" width="20px" height="20px" />
                            </IconButton >
                        </Box>

                        <Divider sx={{ background: '#d2d2d2', height: '1px', my: 1 }} />

                        <Typography className='text2Mid' sx={{ textAlign: 'justify' }}>
                            Lorem ipsum dolor sit amet consectetur. Iaculis egestas volutpat pulvinar sollicitudin eget.
                            Turpis arcu feugiat semper sit arcu dignissim pretium. Tellus vel amet a nibh gravida nisl laoreet gravida.
                            Quam ipsum velit urna aliquam gravida morbi. Nunc sapien dignissim pellentesque quisque.
                            Diam mauris donec pellentesque aliquam id leo ultrices sed. Aliquet nisl pulvinar non netus quam quisque. Lacinia et neque adipiscing elementum vulputate mi elit aliquam enim.
                            Id eu sit nunc erat sagittis turpis.
                            Quam odio ornare sit porta tempus neque. Dolor congue orci in venenatis. Elementum velit duis habitasse quis magnis ultrices. Nulla duis morbi imperdiet posuere.
                            Et consequat nam elementum orci sapien at nascetur semper rutrum. see more
                        </Typography>
                    </Paper>

                    <Paper sx={{ height: 'auto', background: '#F8FAFF', border: '1px solid #005CF64D', boxShadow: '0px 26.398801803588867px 52.797603607177734px -9.89954948425293px #3665D014', my: 4, px: 2, py: 2 }}>
                        <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography className='text1Bold' >
                                Document
                            </Typography>
                            <Box>
                                <IconButton
                                    sx={{
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        padding: '5px',
                                        mx: 2
                                    }}
                                >
                                    <img src={Edit} alt="cover photo" width="20px" height="20px" />
                                </IconButton >

                                <IconButton
                                    style={{
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        padding: '5px',
                                    }}
                                >
                                    <AddIcon sx={{ color: '#2544EE' }} />
                                </IconButton >
                            </Box>
                        </Box>

                        <Divider sx={{ background: '#d2d2d2', height: '1px', my: 1 }} />
                        <Grid container spacing={2}>
                            <Grid item md={3} xs={12} >
                                <Box bgcolor="#F5F7F9" sx={{ borderRadius: '8px 8px 0px 0px', p: 1 }}>
                                    <Typography className='text2Bold' sx={{ color: '#00000' }}>Document</Typography>
                                </Box>
                                <img src={Edit} alt="cover photo" width="70%" height="70%" />
                                <Box bgcolor="#F5F7F9" sx={{ borderRadius: '0px 0px 8px 8px', p: 1 }}>
                                    <Typography className='text2Bold' sx={{ color: '#00000' }}>John Doe-Resume.pdf</Typography>
                                </Box>
                            </Grid>

                            <Grid item md={3} xs={12}>
                                <div>
                                    <label htmlFor="upload-image-input" style={{ textAlign: 'center' }}>
                                        <Input
                                            accept="image/*"
                                            id="upload-image-input"
                                            type="file"
                                            onChange={handleFileUpload}
                                            style={{ height: '100%' }}
                                        />
                                        <Button
                                            variant="contained"
                                            component="span"
                                            disableElevation
                                            sx={{
                                                backgroundColor: '#F5F7F9',
                                                height: '100%',
                                                width: '100%',
                                                '&:hover': {
                                                    backgroundColor: '#fff',
                                                },
                                            }}
                                        >
                                            <img src={Upload} alt="icon" height="200px" width="100%" />

                                        </Button>
                                        <Typography className='text1Bold' >
                                            Upload Your Document
                                        </Typography>
                                    </label>
                                </div>
                            </Grid>

                        </Grid>
                    </Paper>

                    <Paper sx={{ background: '#F8FAFF', border: '1px solid #005CF64D', boxShadow: '0px 26.398801803588867px 52.797603607177734px -9.89954948425293px #3665D014', my: 4, px: 2, py: 2 }}>
                        <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography className='text1Bold' >
                                Workplace Pictures & Videos
                            </Typography>
                            <Box>
                                <IconButton
                                    sx={{
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        padding: '5px',
                                        mx: 2
                                    }}
                                >
                                    <img src={Edit} alt="cover photo" width="20px" height="20px" />
                                </IconButton >

                                <IconButton
                                    style={{
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        padding: '5px',
                                    }}
                                >
                                    <AddIcon sx={{ color: '#2544EE' }} />
                                </IconButton >
                            </Box>
                        </Box>

                        <Divider sx={{ background: '#d2d2d2', height: '1px', my: 1 }} />
                        <Grid container spacing={2}>
                            <Grid item md={3} xs={6}>
                                <img src={Edit} alt="cover photo" width="100%" height="100%" />
                            </Grid>
                            <Grid item md={3} xs={6}>
                                <img src={Edit} alt="cover photo" width="100%" height="100%" />
                            </Grid>
                            <Grid item md={3} xs={6}>
                                <img src={Edit} alt="cover photo" width="100%" height="100%" />
                            </Grid>
                            <Grid item md={3} xs={6}>
                                <img src={Edit} alt="cover photo" width="100%" height="100%" />
                            </Grid>
                        </Grid>

                    </Paper>

                    <Paper sx={{ background: '#F8FAFF', border: '1px solid #005CF64D', boxShadow: '0px 26.398801803588867px 52.797603607177734px -9.89954948425293px #3665D014', my: 4, px: 2, py: 2 }}>
                        <Box sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography className='text1Bold' >
                                Workplace Pictures & Videos
                            </Typography>
                            <Box>
                                <IconButton
                                    sx={{
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        padding: '5px',
                                        mx: 2
                                    }}
                                >
                                    <img src={Edit} alt="cover photo" width="20px" height="20px" />
                                </IconButton >

                                <IconButton
                                    style={{
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        padding: '5px',
                                    }}
                                >
                                    <AddIcon sx={{ color: '#2544EE' }} />
                                </IconButton >
                            </Box>
                        </Box>

                        <Divider sx={{ background: '#d2d2d2', height: '1px', my: 1 }} />
                        <Grid container spacing={2} my={1}>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    sx={{
                                        backgroundColor: '#D9E3F6',
                                        border: 'none',
                                        borderRadius: '10px',
                                        width: '100%',
                                        '& .MuiOutlinedInput-root': {
                                            border: 'none',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                        '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                    }}
                                    variant="outlined"
                                    size="small"
                                    placeholder="Linkedin"
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    sx={{
                                        backgroundColor: '#D9E3F6',
                                        border: 'none',
                                        borderRadius: '10px',
                                        width: '100%',
                                        '& .MuiOutlinedInput-root': {
                                            border: 'none',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                        '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                    }}
                                    variant="outlined"
                                    size="small"
                                    placeholder="Instagram"
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    sx={{
                                        backgroundColor: '#D9E3F6',
                                        border: 'none',
                                        borderRadius: '10px',
                                        width: '100%',
                                        '& .MuiOutlinedInput-root': {
                                            border: 'none',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                        '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                    }}
                                    variant="outlined"
                                    size="small"
                                    placeholder="Twitter"
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    sx={{
                                        backgroundColor: '#D9E3F6',
                                        border: 'none',
                                        borderRadius: '10px',
                                        width: '100%',
                                        '& .MuiOutlinedInput-root': {
                                            border: 'none',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                        '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                    }}
                                    variant="outlined"
                                    size="small"
                                    placeholder="Facebook"
                                />
                            </Grid>
                        </Grid>

                    </Paper>
                </Paper>
            </UserLayout>
        </Layout>

    )
}

export default EmployerProfile